import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

const WindowsNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="windows" />;
};

export default WindowsNode;
